import styled from 'styled-components';

export const Container = styled.div`
  padding: 16px;
`;

export const Header = styled.h1`
  font-family: Poppins;
  font-weight: 700;
  font-style: Bold;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #545454;
  margin: 0;
`;

export const HeaderWrapper = styled.div`
  margin-bottom: 10px;
`;

export const MainCard = styled.div`
  background-color: white;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ContainerForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Section = styled.div`
  background-color: #f6f6f6;
  padding: 16px;
  border-radius: 16px;
`;

export const SectionTitle = styled.h2`
  font-family: Poppins;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: -1%;
  vertical-align: middle;
  color: #222;
  margin: 0;
`;

export const SectionTitleWrapper = styled.div`
  margin-bottom: 8px;
`;

export const SectionText = styled.p`
  color: var(--Takeat-Colors-Neutrals-Grey-02, #7a7a7a);

  /* Body/Body Medium/Medium | 500 */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.25px;
`;

export const SectionTextWrapper = styled.div`
  margin-bottom: 16px;
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-end;
`;

export const InputContainer = styled.div`
  position: relative;
`;

export const InputLabel = styled.label`
  position: absolute;
  top: -8px;
  left: 12px;
  background: transparent;
  padding: 0 4px;
  font-family: Poppins;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.5px;
  vertical-align: middle;
  color: #545454;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 50%;
    background: #f6f6f6;
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50%;
    background: white;
    z-index: -1;
  }
`;

export const InputField = styled.div`
  width: 232px;
  height: 40px;
  border-radius: 12px;
  opacity: 1;
  padding: 8px 16px;
  border: 1px solid #c6c6c6;
  background: white;
  display: flex;
  align-items: center;
  font-family: 'Courier New';
  font-weight: 700;
  font-style: Bold;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: -1%;
  vertical-align: middle;
  color: #222;
`;

export const InfoPrinter = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);

  /* Label/Label Medium/Medium | 500 */
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.5px;
  margin-left: ${({ $infoAutomatic }) => ($infoAutomatic ? 0 : '28px')};
`;

export const CheckboxCard = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 16px;
  background: #fff;
`;

export const ContainerCheckbox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

export const CheckboxItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const CheckboxLabel = styled.label`
  font-family: Poppins;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  vertical-align: middle;
  color: #222;
`;

export const TableContainer = styled.div`
  border-radius: 8px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.14), 0 0 2px 0 rgba(0, 0, 0, 0.12);
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #f6f6f6;
  border-radius: 16px;
  overflow: hidden;
`;

export const TableHeader = styled.thead`
  background-color: #f6f6f6;
`;

export const TableHeaderCell = styled.th`
  padding: 12px;
  text-align: center;
  font-family: Poppins;
  font-weight: 600;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #f6f6f6;
`;

export const TableRow = styled.tr`
  background-color: #fff;

  &:not(:last-child) {
    border-bottom: 1px solid #f6f6f6;
  }
`;

export const TableCell = styled.td`
  padding: 12px;
  text-align: center;
  font-family: Poppins;
  font-size: 14px;
  color: #333;
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  gap: 8px;

  svg {
    font-size: 18px;
  }
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SwitchLabel = styled.label`
  font-family: Poppins;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  vertical-align: middle;
  color: #222;
`;

export const ContainerTypesFonts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-top: 1px solid #ededed;
  padding-top: 8px;
  gap: 10px;
`;

export const TextTitleTypesFonts = styled.span`
  color: var(--Takeat-Colors-Neutrals-Grey-01, #545454);

  /* Title/Title Small/Semibold | 600 */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.15px;
`;

export const FontVisualization = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  align-self: stretch;
`;
